import React from "react";
import {
    getDictionaries,
    getJumpsToUpload,
    getUnits,
    removeJumpsToUpload,
    setDictionaries,
    setJumpsToUpload
} from "../../storage/user";
import * as api from "../../api/skyduck";
import {FORMAT_DISTANCE} from "./util/format";
import {feetToMeters} from "../../util/distance";
import {objectMap} from "../../util/utils";

function getNewJump() {
    return {
        jumpNumber: {
            valid: false,
            touched: false,
            required: true,
            prompt: false
        },
        date: {
            valid: false,
            touched: false,
            required: true,
            prompt: false
        },
        dropzone: {
            valid: false,
            touched: false,
            required: true,
            prompt: false
        },
        iconIDs: []
    }
}

export function mapFormsForAPI(jumps) {
    return jumps.map((jump) => {
        let jumpToChange = jump;

        let iconIDs = jumpToChange.iconIDs;
        delete jumpToChange.iconIDs;

        jumpToChange = objectMap(jumpToChange, field => {
            return field.value;
        });

        jumpToChange.iconIDs = iconIDs.map(icon => {
            return icon.id;
        })

        return jumpToChange;
    })
}

export function isFormsReadyToUpload(jumps) {
    let readyToUpload = true;

    jumps.forEach((jump) => {
        Object.keys(jump).map(function(key, index) {
            if (key !== 'jumpID') {
                let valid = jump[key].valid;
                let touched = jump[key].touched;
                let required = jump[key].required;

                readyToUpload = (
                    readyToUpload && (required ? (touched && valid) : (valid || !touched))
                );
            }
        });
    });

    return readyToUpload;
}

export function changeFormField(jump, field, value, valueToDisplay) {
    let updatedJump = JSON.parse(JSON.stringify(jump));

    if(field === "icon") {
        if(value.toDelete) {
            updatedJump.iconIDs = updatedJump.iconIDs.filter(icon => icon.url !== value.url);
        } else if(value.deleteAll) {
            updatedJump.iconIDs = [];
        } else {
            updatedJump.iconIDs = updatedJump.iconIDs.concat(value);
        }
    } else {
        // Dirty fix...
        let isFeet = field.description.format
            ? (field.description.format === FORMAT_DISTANCE && getUnits() === 'imperial')
            : false

        updatedJump[[`${field.description.name}`]] = {
            value: isFeet ? feetToMeters(value) : value,
            valueToDisplay: valueToDisplay ? valueToDisplay : null,

            touched: true,
            required: field.description.required,
            valid: field.description.validation ? field.description.validation.rule(value) : true,
            prompt: field.description.prompt ? field.description.prompt.rule(value) : false
        };
    }

    return updatedJump;
}

export function touchRequiredFields(jumps) {
    return jumps.map((jump) => {
        let jumpToChange = jump;

        let iconIDs = jumpToChange.iconIDs;
        delete jumpToChange.iconIDs;

        jumpToChange = objectMap(jumpToChange, field => {
            return {
                value: field.value,
                valid: field.valid,
                touched: true,
                required: field.required
            };
        });

        jumpToChange.iconIDs = iconIDs;

        return jumpToChange;
    });
}

function mapJumpFromProps(props, dictionaries, toEdit) {
    let dropzone = props.dropzone ? props.dropzone : '';
    if(dropzone) {
        let matchedDropzone = dictionaries.dropzones.filter(option => {
            let dictionaryDropzone = option.label;
            let match = dictionaryDropzone === dropzone;
            if(!match) {
                let cleanDictionaryDropzone = dictionaryDropzone
                    .toLowerCase().replace(/[^\w\s]/g, '').replace(/\s/g, '');
                let cleanDropzone = dropzone
                    .toLowerCase().replace(/[^\w\s]/g, '').replace(/\s/g, '');

                match = cleanDictionaryDropzone.includes(cleanDropzone);
            }
            return match;
        });

        if(matchedDropzone.length > 0) {
            dropzone = matchedDropzone[0].value;
        } else {
            dropzone = '';
        }
    }

    let jump = {
        jumpNumber: {
            value: props.jumpNumber,
            valid: true,
            touched: true,
            required: true,
            prompt: false
        },
        date: {
            value: props.date,
            valid: true,
            touched: true,
            required: true,
            prompt: false
        },
        dropzone: {
            value: dropzone,
            valueToDisplay: props.dropzone,
            valid: !!dropzone,
            touched: true,
            required: true,
            prompt: false
        },
        iconIDs: props.iconIDs ? props.iconIDs : []
    };

    let assignOptionalField = (name, value, jump) => {
        if (value) {
            return Object.assign({
                [name]: {
                    value: value,
                    valid: true,
                    touched: true,
                    required: false,
                    prompt: false
                },
            }, jump);
        } else {
            return jump;
        }
    }

    if(toEdit) {
        jump = assignOptionalField('jumpID', props.jumpID, jump);
    }

    jump = assignOptionalField('title', props.title, jump);
    jump = assignOptionalField('comment', props.comment, jump);
    jump = assignOptionalField('distanceFromTarget', props.distanceFromTarget, jump);
    jump = assignOptionalField('freeFallTime', props.freeFallTime, jump);
    jump = assignOptionalField('exitAltitude', props.exitAltitude, jump);
    jump = assignOptionalField('deployAltitude', props.deployAltitude, jump);
    jump = assignOptionalField('canopy', props.canopy, jump);
    jump = assignOptionalField('wingsuit', props.wingsuit, jump);
    jump = assignOptionalField('aircraft', props.aircraft, jump);

    let updateDictionary = (value, dictionary) => {
        if(value) {
            let valueExistsInDictionary = dictionary.filter(option => option.value === value).length > 0;
            if(!valueExistsInDictionary) {
                dictionary.push({
                    value: value,
                    label: value
                })
            }
        }
    }

    updateDictionary(props.canopy, dictionaries.canopies);
    updateDictionary(props.aircraft, dictionaries.aircrafts);
    updateDictionary(props.wingsuit, dictionaries.wingsuites);

    return jump;
}

const JUMP_FOR_EDITING = true;

export class FormsHolder extends React.Component {
    constructor(props) {
        super(props);

        let dictionaries = getDictionaries();
        if (!dictionaries) {
            api.dictionaries().then(() => {
                dictionaries = getDictionaries();
            });
        }

        let jumps;

        if(props.oneJumpMode) {
            let originalJump = mapJumpFromProps(props, dictionaries, JUMP_FOR_EDITING);
            let jumpToEdit = mapJumpFromProps(props, dictionaries, JUMP_FOR_EDITING);
            jumps = [originalJump, jumpToEdit];
        } else {
            jumps = getJumpsToUpload() || [];
        }

        setDictionaries(dictionaries);

        this.state = {
            dictionaries: dictionaries,
            jumps: jumps
        }
    }

    updateDictionaries = () => {
        this.setState({
            dictionaries: getDictionaries()
        });
    }

    changeForm = (id, field, value, valueToDisplay) => {
        this.setState(state => {
            let jumps;

            if(this.props.oneJumpMode) {
                jumps = state.jumps.map((jump, j) => {
                    if (j === 0) {
                        return changeFormField(jump, field, value, valueToDisplay);
                    } else {
                        return jump;
                    }
                });
            } else {
                jumps = state.jumps.map((jump, j) => {
                    if (j === id) {
                        return changeFormField(jump, field, value, valueToDisplay);
                    } else {
                        return jump;
                    }
                });
            }

            if(!this.props.oneJumpMode) {
                setJumpsToUpload(jumps);
            }
            return {
                jumps,
            };
        });
    }

    addForm = (jump) => {
        this.setState(state => {
            let dictionaries = this.state.dictionaries;
            const jumps = state.jumps.concat(
                jump
                    ? mapJumpFromProps(jump, dictionaries)
                    : getNewJump()
            );
            setDictionaries(dictionaries);

            if(!this.props.oneJumpMode) {
                setJumpsToUpload(jumps)
            }

            return {
                jumps
            };
        });
    };

    deleteForm = id => {
        this.setState(state => {
            const jumps = state.jumps.filter((item, j) => id !== j);
            setJumpsToUpload(jumps);
            return {
                jumps,
            };
        });
    };

    deleteAllForms = () => {
        if(!this.props.oneJumpMode) {
            removeJumpsToUpload();
        }
        this.setState(state => {
            const jumps = [];
            return {
                jumps
            };
        });
    }

    validateForms = () => {
        this.setState(state => {
            return {
                jumps: touchRequiredFields(state.jumps)
            };
        });
    }

    cancelEditedJump = () => {
        this.setState(state => {
            if(this.props.oneJumpMode) {
                let jumps = state.jumps;
                jumps[0] = jumps[1];
                return jumps;
            }
        });
    }

    updateJumpAfterUpload = () => {
        this.setState(state => {
            if(this.props.oneJumpMode) {
                let jumps = state.jumps;
                jumps[1] = jumps[0];
                return jumps;
            }
        });
    }
}